/** Abertura do WhatsApp com a mensagem pronta.
 *
 *  Nada é enviado pelo sistema: o clique abre o WhatsApp da própria pessoa, com
 *  o número e o texto preenchidos, e ela confere antes de mandar. É o passo que
 *  um envio automático não teria — e é justamente ele que impede um dígito
 *  errado no cadastro de entregar resultado de exame a um estranho.
 */

export interface Telefone {
  /** Número no formato que o wa.me espera: 55 + DDD + número. */
  internacional: string | null;
  problema: string | null;
}

/** Prepara o número para o wa.me.
 *
 *  O cadastro guarda só dígitos de DDD + número, como se digita no Brasil. O
 *  wa.me exige o código do país; sem ele o link abre uma conversa com um número
 *  inexistente, sem erro nenhum na tela. */
export function prepararTelefone(bruto: string | null | undefined): Telefone {
  const d = (bruto ?? '').replace(/\D/g, '');
  if (!d) return { internacional: null, problema: 'sem telefone no cadastro' };

  // Já veio com o código do país.
  if ((d.length === 12 || d.length === 13) && d.startsWith('55')) {
    return { internacional: d, problema: null };
  }
  // DDD + fixo (10) ou DDD + celular (11).
  if (d.length === 10 || d.length === 11) {
    return { internacional: `55${d}`, problema: null };
  }
  return { internacional: null, problema: `telefone com ${d.length} dígitos — confira o cadastro` };
}

/** Monta o endereço do WhatsApp. Funciona no celular (abre o aplicativo) e no
 *  computador (abre o WhatsApp Web, se a pessoa estiver conectada). */
export function linkWhatsapp(telefone: string, mensagem: string): string {
  return `https://wa.me/${telefone}?text=${encodeURIComponent(mensagem)}`;
}

/** Copia a mensagem, para quando o WhatsApp Web não estiver conectado e a
 *  pessoa preferir colar no celular. */
export async function copiar(texto: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(texto);
    return true;
  } catch {
    return false;
  }
}
